module.exports = __webpack_public_path__ + "static/media/loginbanner.1f26963f.jpg";